var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { domel } from '../utils/dom_elem_builder';
import { TimePicker } from './time_picker';
var DefaultTimePicker = /** @class */ (function (_super) {
    __extends(DefaultTimePicker, _super);
    function DefaultTimePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultTimePicker.prototype.setTime = function (time) {
        _super.prototype.setTime.call(this, time);
        this.updateDisplayedTime();
        this.hoursInput.valueAsNumber = time.getHours();
        this.minutesInput.valueAsNumber = time.getMinutes();
    };
    DefaultTimePicker.prototype.render = function () {
        var _this = this;
        domel('div', this.slot)
            .addClass(this.cssPrefix + "-time")
            .addChild('span', function (builder) { return _this.timeText = builder.toDOM(); })
            .toDOM();
        var slidersBuilder = domel('div', this.slot)
            .addClass(this.cssPrefix + "-sliders");
        slidersBuilder
            .addChild('div', function (builder) { return builder
            .addClass(_this.cssPrefix + "-time-row")
            .title('Hours')
            .addChild('input', function (builder) { return _this.hoursInput = builder
            .addClass(_this.cssPrefix + "-input-hours")
            .type('range')
            .attr('min', '0')
            .attr('max', '23')
            .attr('step', '1')
            .on('input', function (e) {
            _this.currentTime.setHours(_this.hoursInput.valueAsNumber);
            _this.updateDisplayedTime();
            _this.timeChanged();
        })
            .toDOM(); }); });
        slidersBuilder
            .addChild('div', function (builder) { return builder
            .addClass(_this.cssPrefix + "-time-row")
            .title('Minutes')
            .addChild('input', function (builder) { return _this.minutesInput = builder
            .addClass(_this.cssPrefix + "-input-minutes")
            .type('range')
            .attr('min', '0')
            .attr('max', '59')
            .attr('step', '1')
            .on('input', function (e) {
            _this.currentTime.setMinutes(_this.minutesInput.valueAsNumber);
            _this.updateDisplayedTime();
            _this.timeChanged();
        })
            .toDOM(); }); });
        return this.slot;
    };
    DefaultTimePicker.prototype.updateDisplayedTime = function () {
        var locale = i18n.getCurrentLocale();
        var timeToDraw = this.currentTime.toLocaleString(locale == 'en' ? undefined : locale, {
            hour: "numeric",
            minute: "numeric"
        });
        this.timeText.innerText = timeToDraw;
    };
    return DefaultTimePicker;
}(TimePicker));
export { DefaultTimePicker };
//# sourceMappingURL=default_time_picker.js.map